import { createSlice } from '@reduxjs/toolkit'

const defaultData = {
  firstName : '',
  memberId : null,
  campaignId : null,
  productList : [],
  billDate : null,
  total : 0,
  isWaiting : false,
  picture : null,
  isBingoUpload : false
}

export const LuckyDrawSlice = createSlice({
  name: 'luckyDraw',
  initialState: defaultData,
  reducers: {
    setLuckyDraw: (state, action) => {
      for (const [key, value] of Object.entries(action.payload)) {
        // console.log(`${key}: ${value}`);
        state[key] = value;
      }
    },
    resetLuckyDraw: () => defaultData
  },
})

// Action creators are generated for each case reducer function
export const {
  setLuckyDraw,
  resetLuckyDraw
} = LuckyDrawSlice.actions

export default LuckyDrawSlice.reducer